/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetUserCardsLightForRoleResources200ResponseInnerUser } from './get-user-cards-light-for-role-resources200-response-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { GetUserCardsLightForRoleResources200ResponseInnerUserAccountGroup } from './get-user-cards-light-for-role-resources200-response-inner-user-account-group';

/**
 * 
 * @export
 * @interface GetUserCardsLightForRoleResources200ResponseInner
 */
export interface GetUserCardsLightForRoleResources200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isCreaditCard'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isOnDemand'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {GetUserCardsLightForRoleResources200ResponseInnerUser}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'user'?: GetUserCardsLightForRoleResources200ResponseInnerUser;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetUserCardsLightForRoleResources200ResponseInnerUserAccountGroup}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'userAccountGroup'?: GetUserCardsLightForRoleResources200ResponseInnerUserAccountGroup;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'resourceScope': GetUserCardsLightForRoleResources200ResponseInnerResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'role': GetUserCardsLightForRoleResources200ResponseInnerRoleEnum;
}

export const GetUserCardsLightForRoleResources200ResponseInnerResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type GetUserCardsLightForRoleResources200ResponseInnerResourceScopeEnum = typeof GetUserCardsLightForRoleResources200ResponseInnerResourceScopeEnum[keyof typeof GetUserCardsLightForRoleResources200ResponseInnerResourceScopeEnum];
export const GetUserCardsLightForRoleResources200ResponseInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type GetUserCardsLightForRoleResources200ResponseInnerRoleEnum = typeof GetUserCardsLightForRoleResources200ResponseInnerRoleEnum[keyof typeof GetUserCardsLightForRoleResources200ResponseInnerRoleEnum];


